import { render } from "./TrainingPlanQuickPreview.vue?vue&type=template&id=3b9c6745"
import script from "./TrainingPlanQuickPreview.vue?vue&type=script&lang=js"
export * from "./TrainingPlanQuickPreview.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/clients.elevatedmacros.com/releases/81682859/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__